// src/lib/utils/devLogger.ts

/**
 * 개발 또는 테스트 환경에서만 콘솔 로그를 출력하는 유틸 함수
 * - development 환경
 * - http 프로토콜 (테스트 서버 등)
 */

const isLocalDev =
  typeof window !== 'undefined'
    ? process.env.NODE_ENV === 'development' || window.location.protocol === 'http:'
    : process.env.NODE_ENV === 'development';

export const devLog = (...args: any[]) => {
  if (isLocalDev) {
    console.log(...args);
  }
};

export const devWarn = (...args: any[]) => {
  if (isLocalDev) {
    console.warn(...args);
  }
};

export const devError = (...args: any[]) => {
  if (isLocalDev) {
    console.error(...args);
  }
};

/**
 * 로그아웃 과정 전용 로그 함수
 */
export const logoutLog = (message: string, data?: any) => {
  if (isLocalDev) {
    const timestamp = new Date().toISOString();
    console.log(`🔓 [LOGOUT ${timestamp}] ${message}`, data || '');
  }
};

/**
 * Flutter 브릿지 통신 전용 로그 함수
 */
export const flutterBridgeLog = (message: string, data?: any) => {
  if (isLocalDev) {
    const timestamp = new Date().toISOString();
    console.log(`🌉 [FLUTTER-BRIDGE ${timestamp}] ${message}`, data || '');
  }
};
